import React from 'react';
import { Stack } from '@mui/material';
import LeadStatusChip from './LeadStatusChip';
import LeadServedByChip from './LeadServedByChip';
import LeadDepartmentChip from './LeadDepartmentChip';

// Linha de status/atendido-por/departamento do LeadCardNormal
// (LeadCardCollapsed repete só o pill de SLA). O pill "Aguardando atendimento" (alerta de SLA) sai da
// linha compacta e ocupa a linha inteira sozinho — é o único estado urgente o
// suficiente para pedir esse destaque; os demais convivem lado a lado.
const LeadAttendanceRow = ({ lead }) => (
  <Stack spacing={0.75}>
    {lead.waitingForHuman && (
      <LeadStatusChip
        status={lead.status}
        waitingForHuman={lead.waitingForHuman}
        waitingForHumanSince={lead.waitingForHumanSince}
        fullWidth
      />
    )}

    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1} flexWrap="wrap" useFlexGap>
      <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
        {!lead.waitingForHuman && (
          <LeadStatusChip
            status={lead.status}
            isAssignedToMe={lead.isAssignedToMe}
            assignedToName={lead.assignedToName}
            lastAssignedToName={lead.lastAssignedToName}
          />
        )}
        <LeadServedByChip
          isAssignedToMe={lead.isAssignedToMe}
          assignedToName={lead.assignedToName}
          lastAssignedToName={lead.lastAssignedToName}
          status={lead.status}
        />
      </Stack>
      <LeadDepartmentChip department={lead.department} />
    </Stack>
  </Stack>
);

export default LeadAttendanceRow;
